import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { ISection } from '../../../interfaces/scheduler_interfaces';

interface IRegistrationSelectedSections {
  isRegistrationPending: boolean;
  disableRegistration: boolean;
  showRegistrationPrompt: boolean;
  isAnyScheduledSectionUnselected: boolean;
  hasAnyScheduledSectionMissingRequirements: boolean;
  hasAnyOptionalSectionNotScheduled: boolean;
  unscheduledOptionalSectionTypes: string[];
  unselectedSections: ISection[];
  coReqMissingSections: ISection[];
  preReqMissingSections: ISection[];
  isRequestPending: boolean;
}

export type IRegistrationSelectedSectionsModel = ITypedModel<IRegistrationSelectedSections>;

angular.module('capability-ng-scheduler').factory('ngRegistrationSelectedSectionsModel', () => {
  return new Model<IRegistrationSelectedSections>({
    isRegistrationPending: false,
    disableRegistration: false,
    showRegistrationPrompt: false,
    isAnyScheduledSectionUnselected: false,
    hasAnyScheduledSectionMissingRequirements: false,
    hasAnyOptionalSectionNotScheduled: false,
    unscheduledOptionalSectionTypes: [],
    unselectedSections: [],
    coReqMissingSections: [],
    preReqMissingSections: [],
    isRequestPending: false
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/registration/models/registration_selected_sections_model.ts